import { Box, Typography } from '@mui/material';
import iconMyRewardSrc from '../../assets/profile-drawer/icon-my-reward.png';
import menuArrowChevronSrc from '../../assets/profile-drawer/menu-arrow-chevron.svg';

export const menuItemLabelSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.5px',
  color: '#fff',
};

function MenuIconBadge({ src, alt, size = 22 }) {
  return (
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: '50%',
        display: 'grid',
        placeItems: 'center',
        flexShrink: 0,
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{ width: size, height: size, objectFit: 'contain', display: 'block' }}
      />
    </Box>
  );
}

/** Figma 9679:1258 + 9679:1260 + 9679:1259 */
function MenuArrowIcon() {
  return (
    <Box
      sx={{
        width: 30,
        height: 30,
        borderRadius: '100px',
        display: 'grid',
        placeItems: 'center',
        flexShrink: 0,
        ml: 'auto',
      }}
    >
      <Box
        component="img"
        src={menuArrowChevronSrc}
        alt=""
        aria-hidden="true"
        sx={{
          width: 20,
          height: 20,
          display: 'block',
        }}
      />
    </Box>
  );
}

/** Figma 10738:14190 + 10738:14191 + 10738:14202 */
function MyRewardsIconBadge() {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 36,
        height: 36,
        flexShrink: 0,
      }}
    >
      <Box
        component="img"
        src={iconMyRewardSrc}
        alt=""
        aria-hidden="true"
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: 36,
          height: 36,
          maxWidth: 'none',
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </Box>
  );
}

export default function ProfileMenuPill({ icon, label, iconVariant, iconSize, onClick }) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        width: '100%',
        maxWidth: 400,
        height: 60,
        borderRadius: '100px',
        border: '5px solid #bf01ff',
        background: 'linear-gradient(180deg, #48003f 0%, #ad009c 100%)',
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        px: '18px',
        cursor: 'pointer',
        color: '#fff',
        textAlign: 'left',
        '&:hover': { opacity: 0.94 },
      }}
    >
      {iconVariant === 'my-rewards' ? (
        <MyRewardsIconBadge />
      ) : (
        <MenuIconBadge src={icon} alt="" size={iconSize} />
      )}
      <Typography sx={{ ...menuItemLabelSx, flex: 1 }}>{label}</Typography>
      <MenuArrowIcon />
    </Box>
  );
}
